import { featureFlags } from './hooks/feature-flags'
import { Client } from '@pi/api-client'

const baseUrl = `${window.location.protocol}${window.PI_API_URL}`

const client = new Client({ baseUrl, featureFlags })

export default client
